export const environment = {
    production: false,
    apiBaseUrl: "https://customerportalapiuat-app.azurewebsites.net/",
    msalRedirect: "https://beta-shop.ppg.tikkurila.com"
};
